import { useEffect } from 'react'
import { useGLTF } from '@react-three/drei'
import { useViewerStore } from '@/store/viewer-store'
import * as THREE from 'three'

interface ContainerModelProps {
  modelPath: string
}

export const ContainerModel = ({ modelPath }: ContainerModelProps) => {
  const setLoading = useViewerStore((state) => state.setLoading)
  const setError = useViewerStore((state) => state.setError)

  useEffect(() => {
    setLoading(true)
    setError(null)
  }, [modelPath, setLoading, setError])

  // Load the model - useGLTF returns error as part of the result
  const { scene, error } = useGLTF(modelPath) as { scene: THREE.Group; error?: Error }

  useEffect(() => {
    if (error) {
      setError(error.message || 'Failed to load 3D model')
      setLoading(false)
    } else if (scene) {
      setLoading(false)
    }
  }, [scene, error, setLoading, setError])

  if (error) return null
  if (!scene) return null

  return <primitive object={scene} />
}

// Preload will happen dynamically from viewer component
